export default "__VITE_ASSET__qjUOhMWA__"